var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';
export const Button = (_a) => {
    var { size = 'medium', variant = 'contained', children, onClick, className = null, isLoading = false, fullWidth = false, includeChevron = false, chevronPosition = 'right', transparent = false } = _a, props = __rest(_a, ["size", "variant", "children", "onClick", "className", "isLoading", "fullWidth", "includeChevron", "chevronPosition", "transparent"]);
    const iconColour = variant === 'text' || variant === 'outlined' ? 'blue' : 'white';
    const iconUrl = `https://www.haven.com/assets/icons/arrow-ios-right-${iconColour}.svg`;
    return (<button onClick={isLoading ? undefined : onClick} className={clsx(styles.button, styles[variant], styles[size], className, fullWidth && styles.fullWidth, isLoading && styles.loading, transparent && styles.transparent)} {...props}>
      {includeChevron && chevronPosition === 'left' && (<img src={iconUrl} alt='button icon' className={clsx(styles.chevron, styles.chevronLeft)}/>)}
      {children}
      {includeChevron && chevronPosition === 'right' && (<img src={iconUrl} alt='button icon' className={clsx(styles.chevron, styles.chevronRight)}/>)}
    </button>);
};
